module.exports = __webpack_public_path__ + "img/st_joseph.33421893.png";